// ------------------------------------------
// 横スクロールの位置バー
// ------------------------------------------
class ScrollBar {
  constructor(el, opt) {
    this.items = document.querySelectorAll('.' + el);
    if (this.items.length > 0) {
      this.event();
    }
  }

  event() {
    this.items.forEach((item) => {
      const area = item.querySelector('.js-scrollbar-area');
      const thumb = item.querySelector('.js-scrollbar-thumb');
      if (!area || !thumb) return;

      const update = () => {
        const track = thumb.parentElement;
        const trackWidth = track.clientWidth - thumb.offsetLeft * 2;
        const max = area.scrollWidth - area.clientWidth;
        if (max <= 0 || trackWidth <= 0) return;

        const thumbWidth = Math.max(trackWidth * (area.clientWidth / area.scrollWidth), trackWidth * 0.2);
        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${(trackWidth - thumbWidth) * (area.scrollLeft / max)}px)`;
      };

      area.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
}
